import { render, staticRenderFns } from "./TbodyRibbonBalances.vue?vue&type=template&id=b6c595a0"
import script from "./TbodyRibbonBalances.vue?vue&type=script&lang=js"
export * from "./TbodyRibbonBalances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports